/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Task_Completed_Creator_TitleInputs */

const en_notifications_task_completed_creator_title = /** @type {(inputs: Notifications_Task_Completed_Creator_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task you created was completed`)
};

const pt_br2_notifications_task_completed_creator_title = /** @type {(inputs: Notifications_Task_Completed_Creator_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma atividade que você criou foi concluída`)
};

/**
* | output |
* | --- |
* | "Task you created was completed" |
*
* @param {Notifications_Task_Completed_Creator_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_completed_creator_title = /** @type {((inputs?: Notifications_Task_Completed_Creator_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Completed_Creator_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_completed_creator_title(inputs)
	return pt_br2_notifications_task_completed_creator_title(inputs)
});